import type { TellentClientSetupEnvironment } from './interface';

export const environment = <TellentClientSetupEnvironment>{};
